
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"title":"Druckbericht abonnieren","filter.invalid.warning.dialog.title":"Unvollständige Filterbelegung","filter.invalid.warning.dialog.message":"Bitte Pflichtfilter auswählen."},"en":{"title":"Subscribe to report","filter.invalid.warning.dialog.title":"Incomplete filter configuration","filter.invalid.warning.dialog.message":"Please select mandatory filters."}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();